import { ReactElement } from "react";
import { HelpDeskPrompt } from "./help-desk-prompt";
import { EnhancedAccount } from "src/hooks/use-account-enhanced";

export function PageBase({
    pageName,
    children,
    userPermitted,
    enhancedAccount = undefined,
}: {
    pageName: string;
    children: ReactElement;
    userPermitted: boolean;
    enhancedAccount?: EnhancedAccount | undefined;
}) {
    return userPermitted ? (
        <div className="flex h-full bg-base-200" data-theme="corporate">
            {children}
        </div>
    ) : enhancedAccount?.loading ? (
        <div className="flex h-full items-center justify-center">
            <span className="loading loading-spinner loading-lg" />
        </div>
    ) : enhancedAccount != undefined ? (
        <HelpDeskPrompt
            pageName={pageName}
            enhancedAccount={enhancedAccount}
        ></HelpDeskPrompt>
    ) : (
        <div className="p-4 label-text text-white">
            Permission denied, you shouldn't be here...
        </div>
    );
}
